// JS for Partner search

import $ from 'jquery'

if ($('.input-zip').length) {

    var zipAutocompleteWidgetCompany = null;
    var zipAutocompleteWidgetCategory = null;

    $(window).on('load', function() {
      var googleScriptElement = $('<script async />');
      $(googleScriptElement).prop('src', `${EAPLUS_VARS.google_script_url}&callback=window.createZipAutocomplete`);
      $('head').append(googleScriptElement);
    });

    window.createZipAutocomplete = function createZipAutocomplete() {
        //var field = document.getElementById('inputZip');
        var fields = document.getElementsByClassName('input-zip');
        var options = {
            types: ['(regions)'],
            componentRestrictions: {
                country: ['US']
            }
        };
        Array.from(fields).forEach((field) => {

            // Prevent the Enter key from causing a form-submission.
      field.addEventListener('keydown', function (event) {
         console.log('Preventing the Enter key from causing a form-submission');
         if (event.keyCode === 13) {
            event.preventDefault();
         }
      });

            // Do stuff here
            if (field.id == 'inputZipCompany') {
                var autocomplete = new google.maps.places.Autocomplete(field, options);
                // Create the Google Places Autocomplete widget.
                zipAutocompleteWidgetCompany = new google.maps.places.Autocomplete(
                    field,
                    options
                );
                // When the Autocomplete widget raises the place_changed event,
                // call our populateZipFromAutocomplete() function.
                zipAutocompleteWidgetCompany.addListener('place_changed', populateCompanyZipFromAutocomplete);
            } else {
                var autocomplete = new google.maps.places.Autocomplete(field, options);
                // Create the Google Places Autocomplete widget.
                zipAutocompleteWidgetCategory = new google.maps.places.Autocomplete(
                    field,
                    options
                );
                // When the Autocomplete widget raises the place_changed event,
                // call our populateZipFromAutocomplete() function.
                zipAutocompleteWidgetCategory.addListener('place_changed', populateCategoryZipFromAutocomplete);
            }

        });
    }

    /**
    * This is our main handler, which is called each time the user picks an
    * autocomplete suggested address.
    */
    function populateCompanyZipFromAutocomplete() {
        // Get the suggested "place" object from the widget.
        const place = zipAutocompleteWidgetCompany.getPlace();
        if (!place) {
            console.log('Invalid / missing place from Google API');
        } else {
        if (getZipAddressComponent(place, 'administrative_area_level_1', 'short_name') == 'NY') {
            //$('#checkout-notice-ny').modal('show');
            var alert = '<div class="alert alert-secondary w-100 mt-3 mb-0" role="alert"><svg class="svg-icon h5 mb-0 me-1 text-white"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="https://emergencyassistanceplus.test/wp-content/themes/eaplus/assets/sprite/icons.svg#icon-x-circle"></use></svg> EA+ is not available in your area.</div>';
            $('.alert-wrapper').append(alert);
        } else {
            $('#browse-partner-company').removeAttr('disabled');
        }
            $('#inputZipCompany').val(getZipAddressComponent(place, 'postal_code'));
        }

    }

    function populateCategoryZipFromAutocomplete() {
        // Get the suggested "place" object from the widget.
        const place = zipAutocompleteWidgetCategory.getPlace();
        if (!place) {
            console.log('Invalid / missing place from Google API');
        } else {
        if (getZipAddressComponent(place, 'administrative_area_level_1', 'short_name') == 'NY') {
            //$('#checkout-notice-ny').modal('show');
            var alert = '<div class="alert alert-secondary w-100 mt-3 mb-0" role="alert"><svg class="svg-icon h5 mb-0 me-1 text-white"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="https://emergencyassistanceplus.test/wp-content/themes/eaplus/assets/sprite/icons.svg#icon-x-circle"></use></svg> EA+ is not available in your area.</div>';
            $('.alert-wrapper').append(alert);
        } else {
            $('#browse-partner-category').removeAttr('disabled');
        }
            $('#inputZipCategory').val(getZipAddressComponent(place, 'postal_code'));
        }

    }

    /**
    * Scan a Google "place" object for a specific component
    * and return either its short_name or long_name.
    */
    function getZipAddressComponent(place, componentType, componentLength) {
        // const place = zipAutocompleteWidget.getPlace();
        if (!componentLength) {
        componentLength = 'short_name';
        }

        var componentValue = null;
        for (const component of place.address_components) {
        if (component.types[0] == componentType) {
            componentValue = component[componentLength];
            break;
        }
        }

        if (componentValue == null) {
        return '';
        }

        if (componentType == 'street_number') {
        return componentValue + ' ';
        }

        return componentValue;
    }

}
